import { useState } from "react";
import { IconChevronDown } from "@tabler/icons-react";
import useNotification from "../notification/use_notification";
import { SelectType, ModifierByType } from "./common";
function AddPromotion({ open, addPromotion }) {
  const [state, setState] = useState(baseState);
  const notify = useNotification();
  const handleChange = (e) =>
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  const handleSubmit = () => {
    if (!state.discount_identifier) {
      notify.error("error", "invalid code name");
      return;
    }
    const discount_type = parseInt(state.discount_type);
    if (!discount_type || discount_type === -1) {
      notify.error("error", "invalid type");
      return;
    }
    if (!state.discount_modifier && discount_type !== 4) {
      notify.error("error", "invalid modifier");
      return;
    }
    if (!state.expiration_date) {
      notify.error("error", "invalid expiration date");
      return;
    }
    addPromotion({
      ...state,
      discount_type: discount_type,
      discount_modifier: parseInt(state.discount_modifier) || 0,
      expiration_date: new Date(state.expiration_date)
        .toISOString()
        .split(".")[0],
    });
  };
  const handleCancel = () => {
    setState({});
  };
  return (
    <div>
      {open && (
        <div className="flex items-center gap-6 my-6 border rounded-md shadow-md p-4">
          <div>
            <input
              id="discount_identifier"
              name="discount_identifier"
              type="text"
              placeholder="bigblue10"
              onChange={handleChange}
              value={state.discount_identifier}
              className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
            />
          </div>
          <SelectType
            onChange={handleChange}
            value={state.discount_type}
            name="discount_type"
          />
          <ModifierByType
            type={state.discount_type}
            onChange={handleChange}
            value={state.discount_modifier}
            id="discount_modifier"
            name="discount_modifier"
          />
          <div>
            <input
              id="message"
              name="message"
              type="text"
              onChange={handleChange}
              value={state.message}
              placeholder="message"
              className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
            />
          </div>
          <div>
            <input
              id="expiration_date"
              name="expiration_date"
              onChange={handleChange}
              value={state.expiration_date}
              type="date"
              className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
            />
          </div>
          <div className="flex gap-2 ms-auto">
            <button
              onClick={handleCancel}
              type="button"
              className="block rounded-md bg-red-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
            >
              Cancel
            </button>

            <button
              onClick={handleSubmit}
              type="button"
              className="block rounded-md bg-green-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
            >
              Add
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
const baseState = {
  discount_identifier: "",
  discount_type: -1,
  discount_modifier: "",
  message: "",
  expiration_date: "",
};
export default AddPromotion;
